(function ($) {
    $('.single-block').each(function (index) {
        let tab = $(this).data('tab');
        let btn = $(this);

        btn.click(function () {
            if (window.matchMedia("(max-width: 959px)").matches) {
                let activeTab = $(".toggle-list-mobile ul").find(`[data-tab='${tab}']`);
                activeTab.click();

                activeTab.on('click', function () {
                    if ($(this).hasClass('active')) return;
                    const parent = $(this).closest('.toggle-list-mobile');
                    const tabName = $(this).text();
                    const nav = $(parent).find('ul');
                    const tab = $(this).data('tab');

                    $(this).addClass('active').siblings().removeClass('active');
                    parent.toggleClass('active');
                    parent.find('.header p').text(tabName);

                    $('.single-tab-content').removeClass('active').filter(`[data-tab="${tab}"]`).addClass('active');
                    $('.steps-navigation li').removeClass('visible').filter(`[data-tab="${tab}"]`).addClass('visible');
                    $('.step-title.visible').removeClass('previous-step');
                    $(`.step-title[data-tab="${tab}"]`).eq(0).addClass('active');
                });
                $('.toggle-list-mobile ul').hide();
                $('.toggle-list-mobile.active').removeClass('active');
                $('html, body').animate({
                    scrollTop: $(".steps-content-block").offset().top,
                }, 'slow');
            } else {
                let attr = $(this).attr('data-tab');

                if (typeof attr !== 'undefined' && attr !== false) {
                    let activeTab = $(".steps-content-block #tabs ").find(`[data-tab='${tab}']`);
                    activeTab.click();
                    $('html, body').animate({
                        scrollTop: $(".steps-content-block #tabs").offset().top - 160,
                    }, 'slow');
                }
            }
        })
    });

})(jQuery);
